// Import stylów Bootstrap (CSS framework dla wyglądu)
import 'bootstrap/dist/css/bootstrap.css'

// Import podstawowych funkcji Vue 3
import { createApp } from 'vue'

// Import Pinia (store zarządzający stanem aplikacji)
import { createPinia } from 'pinia'

// Import głównego komponentu aplikacji
import CarViver from './CarViver.vue'

// Import routera (obsługa tras/ścieżek)
import router from './router'

// Import biblioteki i18n do tłumaczeń
import { createI18n } from 'vue-i18n'

// Import plików z tłumaczeniami dla poszczególnych języków
import en from './locales/en.json'
import pl from './locales/pl.json'
import lt from './locales/lt.json'
import de from './locales/de.json'
import ro from './locales/ro.json'
import ua from './locales/ua.json'
import { isSG } from './config/appVersion'

if (!isSG) {
  const fontLink = document.createElement('link')
  fontLink.rel = 'stylesheet'
  fontLink.type = 'text/css'
  fontLink.href = 'https://fonts.googleapis.com/css?family=Ubuntu:regular,bold&subset=Latin'
  document.head.appendChild(fontLink)
}

// Tworzymy instancję Pinia (globalny store)
const pinia = createPinia()

// Pobieramy język zapisany w localStorage, domyślnie 'pl'
const savedLang = localStorage.getItem('lang') || 'pl';

// Tworzymy instancję i18n z tłumaczeniami
const i18n = createI18n({
  legacy: false,                 // Nowy sposób korzystania (Composition API)
  locale: savedLang,             // Aktualny język
  fallbackLocale: 'pl',          // Język zapasowy, jeśli czegoś nie przetłumaczono
  messages: { pl, en, lt, de, ro, ua }, // Dostępne tłumaczenia
})

// Tworzymy instancję aplikacji Vue na podstawie komponentu CarViver
const app = createApp(CarViver)

// Dodajemy Pinia (store) do aplikacji
app.use(pinia)

// Dodajemy router (nawigacja po widokach) do aplikacji
app.use(router)

// Dodajemy tłumaczenia i18n do aplikacji
app.use(i18n)

// Shortcut – pozwala używać this.t('klucz') w komponentach Options API
app.config.globalProperties.t = i18n.global.t

// Montujemy aplikację do elementu o id #app (w index.html)
app.mount('#app')

// Eksportujemy i18n (przydatne np. w store Pinia)
export { i18n }
